export default __webpack_public_path__ + "static/media/elin_ΦΑ.75b9b022.png";